// src/components/admin/PaymentRequestList.js
import React from 'react';
import styles from './Admin.module.css';

const PaymentRequestList = ({ paymentRequests, onApprove, onReject, isPending = true, isProcessed = false }) => {
  // 日時をフォーマット
  const formatDate = (dateString) => {
    if (!dateString) return '不明';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(date);
  };

  // リクエストからの経過時間を計算
  const getElapsedTime = (dateString) => {
    if (!dateString) return '不明';
    const requestDate = new Date(dateString);
    const now = new Date();
    const elapsed = now - requestDate;
    
    // ミリ秒を分に変換
    const minutes = Math.floor(elapsed / 60000);
    
    if (minutes < 1) {
      return "たった今";
    } else if (minutes < 60) {
      return `${minutes}分前`;
    } else {
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return `${hours}時間${minutes % 60}分前`;
      } else {
        const days = Math.floor(hours / 24);
        return `${days}日前`;
      }
    }
  };
  
  // 処理済みの支払いリクエスト用のアイテムレンダリング
  const renderProcessedItem = (request) => {
    const isApproved = request.processType === 'approved';
    
    return (
      <div key={request.userId} className={`${styles.paymentItem} ${isApproved ? styles.paymentItemApproved : styles.paymentItemRejected}`}>
        <div className={styles.paymentHeader}>
          <h3 className={styles.customerName}>{request.userDisplayName}</h3>
          <span className={`${styles.paymentStatusBadge} ${isApproved ? styles.statusBadgeApproved : styles.statusBadgeRejected}`}>
            {isApproved ? '承認済み' : '拒否済み'}
          </span>
        </div>
        
        <div className={styles.paymentTimestampRow}>
          <div className={styles.paymentInfoGroup}>
            <p className={styles.paymentDate}>
              処理日時: {formatDate(request.processedAt)}
            </p>
            <p className={styles.paymentElapsed}>
              {getElapsedTime(request.processedAt)}
            </p>
            <p className={styles.companyInfo}>
              会社: {request.company || '未設定'}
            </p>
          </div>
          
          <div className={styles.processInfo}>
            <p className={styles.processInfoText}>
              {isApproved 
                ? '支払いが承認されました' 
                : '支払いが拒否されました'}
            </p>
          </div>
        </div>
      </div>
    );
  };
  
  // 処理待ちの支払いリクエスト用のアイテムレンダリング
  const renderPendingItem = (request) => {
    return (
      <div key={request.userId} className={styles.paymentItem}>
        <div className={styles.paymentHeader}>
          <h3 className={styles.customerName}>{request.userDisplayName}</h3>
          <span className={styles.paymentStatusBadge}>
            処理待ち
          </span>
        </div>
        
        <div className={styles.paymentTimestampRow}>
          <div className={styles.paymentInfoGroup}>
            <p className={styles.paymentDate}>
              リクエスト日時: {formatDate(request.paymentRequestedAt)}
            </p>
            <p className={styles.paymentElapsed}>
              {getElapsedTime(request.paymentRequestedAt)}
            </p>
            <p className={styles.companyInfo}>
              会社: {request.company || '未設定'}
            </p>
          </div>
          
          {/* アクションボタン */}
          <div className={styles.paymentActions}>
            <button
              onClick={() => onApprove(request.userId)}
              className={styles.approveButton}
            >
              承認する
            </button>
            <button
              onClick={() => onReject(request.userId)}
              className={styles.rejectButton}
            >
              拒否する
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.sectionList}>
      {paymentRequests.map(request => 
        isProcessed 
          ? renderProcessedItem(request) 
          : renderPendingItem(request)
      )}
    </div>
  );
};

export default PaymentRequestList;